import { ToolBase } from ".";
import { fabric } from "../fabric";

export class PencilTool extends ToolBase {

  /**
   * @inheritdoc
   */
  constructor(imageEditor, name, opts) {
    super(imageEditor, name, opts);

    let styleModule = this.imageEditor.getModule("style");
    
    this.imageEditor.canvas.freeDrawingBrush.width = styleModule.strokeSize;
    this.imageEditor.canvas.freeDrawingBrush.color = styleModule.strokeColor;
    
    styleModule.on("change", (data) => {
      this.imageEditor.canvas.freeDrawingBrush.width = data.strokeSize;
      this.imageEditor.canvas.freeDrawingBrush.color = data.strokeColor;
    })

  }

  setActive(value) {
    let styleModule = this.imageEditor.getModule("style");
    super.setActive(value);
    this.imageEditor.canvas.isDrawingMode = value;

    if(value){
      this.imageEditor.canvas.freeDrawingBrush = new fabric.PencilBrush(this.imageEditor.canvas);
      this.imageEditor.canvas.freeDrawingBrush.color = styleModule.strokeColor;
      this.imageEditor.canvas.freeDrawingBrush.width = styleModule.strokeSize;
    }
  }

}